module.exports = __webpack_public_path__ + "static/img/A6233.4612af8e.png";